<template>
  <div class="border-2 h-screen">
    <div
      id="mapMain"
      class="h-screen w-full"
    />
  </div>
</template>

<script>
import '@maplibre/maplibre-gl-leaflet'
import 'leaflet.markercluster'
import L from 'leaflet'
import bright from '@/data/osm-libre.json'
import axios from 'axios'
import 'beautifymarker'
import salzburg from '../data/salzburg_geo.json'

L.Mask = L.Polygon.extend({
  options: {
    stroke: false,
    color: '#333',
    fillOpacity: 0.5,
    clickable: true,

    outerBounds: new L.LatLngBounds([-90, -360], [90, 360])
  },

  initialize: function (latLngs, options) {
    const outerBoundsLatLngs = [
      this.options.outerBounds.getSouthWest(),
      this.options.outerBounds.getNorthWest(),
      this.options.outerBounds.getNorthEast(),
      this.options.outerBounds.getSouthEast()
    ]
    L.Polygon.prototype.initialize.call(this, [outerBoundsLatLngs, latLngs], options)
  }

})
L.mask = function (latLngs, options) {
  return new L.Mask(latLngs, options)
}

export default {
  components: {
  },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    zoom: {
      type: Number,
      default: 10
    },
    latLng: {
      type: Array,
      default: () => { return [47.585833, 12.693611] }
    },
    height: {
      type: String,
      default: '100%'
    }
  },
  data () {
    return {
      map: null,
      gl: null,
      tracksLayer: null,
      objects: [],
      token: 'iYDuJwYdwkwDBuGAy7i22ZtV',
      api: 'https://japi.cms.next.tourismusnetz.com',
      gpxData: null
    }
  },
  computed: {
    getStyle () {
      return {
        height: this.height,
        width: this.width
      }
    }
  },
  async mounted () {
    this.map = L.map('mapMain', { minZoom: 5, maxZoom: 17 }).setView([47.585833, 12.693611], 5)
    this.map.setMaxBounds([-34.49296, 29.735139, 46.75348, 81.47299])
    this.gl = L.maplibreGL({
    // get your own MapTiler token at https://cloud.maptiler.com/ or use MapBox style
      style: bright
    }).addTo(this.map)

    const maplibreMap = this.gl.getMaplibreMap()

    const coordinates = salzburg.features[0].geometry.coordinates[0]

    const latLngs = []
    for (const coordinate of coordinates) {
      latLngs.push(new L.LatLng(coordinate[1], coordinate[0]))
    }

    maplibreMap.on('load', () => {
      this.map.flyTo([47.585833, 12.693611], 8)

      maplibreMap.addSource('states', {
        type: 'geojson',
        data: L.mask(latLngs).toGeoJSON()
      })

      maplibreMap.addLayer({
        id: 'state-fills',
        type: 'fill',
        source: 'states',
        layout: {},
        paint: {
          'fill-color': '#000',
          'fill-opacity': 0.2
        }
      })
    })

    const objects = await this.loadObjects()
    const markers = L.markerClusterGroup({
      disableClusteringAtZoom: 16,
      spiderfyOnMaxZoom: false,
      animate: true,
      showCoverageOnHover: false
    })
    for (const object of objects) {
      const marker = L.marker(object.latLng, {
        title: object.name,
        icon: L.BeautifyIcon.icon({
          icon: 'bed',
          iconShape: 'marker',
          borderColor: 'white',
          backgroundColor: 'red',
          textColor: 'white'
        })
      })
      marker.bindPopup(object.name)
      markers.addLayer(marker)
    }
    this.map.addLayer(markers)
  },
  methods: {
    async loadObjects () {
      const url = `${this.api}/search/maps/all/${this.token}/3`
      try {
        const response = await axios.get(url)
        return response.data
      } catch (error) {
        console.log(error)
      }
      return []
    }
  }
}
</script>

<style>
.widget {
  max-width: 400px;
  margin: 0 auto;
}

.region {
  border-top: 1px solid #eee;
  padding: 16px;
  background: transparent;
}

.region-name {
  font-size: 20px;
  margin-bottom: 8px;
}

.region-path {
  font-size: 14px;
  color: rgba(0, 0, 0, 0.54);
}
</style>
<style>
   @import '../assets/index.css';
</style>
